import React, { useEffect, useState } from "react";
import { EnvelopeSimple, CaretDown, CaretUp, Users } from "@phosphor-icons/react";
import { api, API } from "../lib/api";
import { shareOrigin } from "../lib/shareOrigin";
import InlineShareButton from "../components/InlineShareButton";

function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      weekday: "long", month: "long", day: "numeric", year: "numeric",
      timeZone: "America/Los_Angeles",
    });
  } catch {
    return iso;
  }
}

export default function EmailArchivePage() {
  const [items, setItems] = useState(null);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    api.get("/email/archive")
      .then(({ data }) => {
        setItems(data.items || []);
        if ((data.items || []).length > 0) setOpenId(data.items[0].id);
      })
      .catch(() => setItems([]));
  }, []);

  return (
    <div className="min-h-screen bg-tac-bg text-tac-text">
      <main className="max-w-3xl mx-auto px-3 sm:px-6 py-8" data-testid="email-archive-page">
        <div className="mb-6">
          <div className="flex items-center gap-2 text-tac-primary text-[11px] font-bold uppercase tracking-[0.2em]">
            <EnvelopeSimple size={14} weight="fill" /> Member Newsletter
          </div>
          <h1 className="font-display font-black text-2xl sm:text-3xl mt-1">Weekly Updates Archive</h1>
          <p className="text-sm text-tac-dim mt-2 max-w-xl">
            Every weekly update sent to Firewatch members is archived here so new members can
            catch up on fire activity, evacuations and lightning across the region.
          </p>
        </div>

        {items === null && (
          <div className="text-sm text-tac-dim py-10 text-center" data-testid="archive-loading">Loading archive…</div>
        )}

        {items !== null && items.length === 0 && (
          <div
            className="border border-tac-border bg-tac-surface/40 rounded-sm p-8 text-center"
            data-testid="archive-empty"
          >
            <EnvelopeSimple size={28} className="mx-auto text-tac-faint mb-3" />
            <div className="text-sm font-bold text-tac-text">No weekly updates archived yet</div>
            <div className="text-xs text-tac-dim mt-1">
              The next weekly member update will appear here automatically after it's sent.
            </div>
          </div>
        )}

        <div className="space-y-3">
          {(items || []).map((it) => {
            const open = openId === it.id;
            return (
              <div key={it.id} className="border border-tac-border bg-tac-surface/40 rounded-sm overflow-hidden">
                <div className="flex items-center gap-1 pr-2">
                  <button
                    data-testid={`archive-item-${it.id}`}
                    onClick={() => setOpenId(open ? null : it.id)}
                    className="flex-1 min-w-0 flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-tac-surface2/50 transition-colors"
                  >
                    <div className="min-w-0">
                      <div className="text-sm font-bold text-tac-text truncate">{it.subject}</div>
                      <div className="text-[11px] text-tac-dim mt-0.5 flex items-center gap-3">
                        <span>{fmtDate(it.at)}</span>
                        {it.sent > 0 && (
                          <span className="inline-flex items-center gap-1">
                            <Users size={11} weight="bold" /> {it.sent} members
                          </span>
                        )}
                      </div>
                    </div>
                    {open ? (
                      <CaretUp size={14} weight="bold" className="text-tac-primary shrink-0" />
                    ) : (
                      <CaretDown size={14} weight="bold" className="text-tac-dim shrink-0" />
                    )}
                  </button>
                  <InlineShareButton
                    variant="compact"
                    testid={`archive-share-${it.id}`}
                    url={`${shareOrigin()}/api/email/archive/${it.id}`}
                    title={it.subject}
                    text={`${it.subject} — Okanogan Highlands Firewatch weekly update`}
                    caption={[
                      `📬 ${it.subject}`,
                      `The Firewatch weekly update for ${fmtDate(it.at)} — fires, containment, evacuation levels and lightning across the region.`,
                      "",
                      `${shareOrigin()}/api/email/archive/${it.id}`,
                    ].join("\n")}
                  />
                </div>
                {open && (
                  <iframe
                    title={it.subject}
                    src={`${API}/email/archive/${it.id}`}
                    className="w-full border-t border-tac-border bg-[#111]"
                    style={{ height: "70vh" }}
                    data-testid={`archive-frame-${it.id}`}
                  />
                )}
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
